import { sleekRarityColor } from './rarityColor';

type Props = {
  badgeName: string | null | undefined;
};

/**
 * Soft rarity-coloured light behind a card (partner Figma 2026-10-08: a 182px
 * ellipse at 70% under a 250px layer blur). A radial gradient draws the same
 * haze without a blur filter. Fills its positioned parent and centres there;
 * nothing for a card without a known tier.
 */
export function RarityGlow({ badgeName }: Props) {
  const color = sleekRarityColor(badgeName);
  if (!color) return null;
  return (
    <span
      aria-hidden
      className="pointer-events-none absolute left-1/2 top-1/2 h-[560px] w-[560px] -translate-x-1/2 -translate-y-1/2 rounded-full"
      style={{
        background: `radial-gradient(closest-side, color-mix(in srgb, ${color} 55%, transparent), color-mix(in srgb, ${color} 22%, transparent) 50%, transparent)`,
      }}
    />
  );
}
